// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/workdoc/CarDamageContainer.css
// module id = 2047
// module chunks = 0